import React, { useContext } from 'react';
import { useConfig } from 'base-shell/lib/providers/Config';
import { Box, AppBar, Toolbar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import MenuContext from 'providers/Menu/Context';

import { BackButton, MenuButton, CartButton } from 'components/IconButtons';
import Logo from 'components/Logo';
import RoutesMenu from './RoutesMenu';

import {
  LogoStyle,
  ToolbarStyle,
  AppBarStyle,
  AppBarSpaceStyle,
} from './style';
import { HIDE_ORDER, baseRoute } from 'config/const';
import { useCarts } from 'providers/Cart';

function CustomAppbar({
  enableMenu,
  enableCart,
  pageTitle,
  appBarContent,
  onBackClick,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { carts } = useCarts();

  const { appConfig } = useConfig();
  const { appbar: defaultAppbar } = appConfig || {};

  const { toggleThis, isMenuOpen } = useContext(MenuContext);
  const { appBarLeadingContent = null } = defaultAppbar || {};

  let headerTitle = '';
  if (typeof pageTitle === 'string' || pageTitle instanceof String)
    headerTitle = pageTitle;

  const onCartClick = () => {
    navigate(`${baseRoute}/carts`);
  };
  const handleDrawerMenuClick = (isMenuOpen) => {
    toggleThis('isMenuOpen', isMenuOpen);
  };

  return (
    <Box>
      <AppBar sx={AppBarStyle(theme)}>
        <Toolbar sx={ToolbarStyle}>
          <BackButton onBackClick={onBackClick} />
          <MenuButton
            enableMenu={enableMenu}
            handleDrawerMenuClick={() => handleDrawerMenuClick(!isMenuOpen)}
          />

          <Logo sx={LogoStyle} />
          {appBarLeadingContent}
          <Typography variant="h3" noWrap>
            {headerTitle}
          </Typography>
          {enableCart && !HIDE_ORDER && (
            <CartButton cartLength={carts.length} onCartClick={onCartClick} />
          )}
          <Box sx={AppBarSpaceStyle} />
          {appBarContent}
        </Toolbar>
      </AppBar>
      {enableMenu && (
        <RoutesMenu
          isMenuOpen={isMenuOpen}
          toggleDrawer={() => handleDrawerMenuClick(false)}
        />
      )}
    </Box>
  );
}

export default CustomAppbar;
